module.exports = __webpack_public_path__ + "static/media/hitsend.4e809859.svg";